import classNames from 'classnames';
import React, { forwardRef } from 'react';

const HEADINGS = {
  1: 'h1',
  2: 'h2',
  3: 'h3',
  4: 'h4',
  5: 'h5',
  6: 'h6',
} as const;

export type HeadingLevel = keyof typeof HEADINGS;

type Props = {
  block?: boolean; // KU – use the heading's default block styling
  children: React.ReactNode;
  focusable?: boolean;
  level: HeadingLevel;
} & React.ComponentProps<'h1'>;

export const Heading = forwardRef<HTMLDivElement, Props>(
  ({ block, children, className, focusable = true, level, ...props }: Props, ref) => {
    const HeadingElement = HEADINGS[level];

    if (!HeadingElement) {
      return null;
    }

    const tabIndex = focusable ? -1 : undefined;

    const headingClass = classNames(className, {
      'a11y-heading': !block,
    });

    return (
      <HeadingElement
        ref={ref}
        className={headingClass || undefined}
        tabIndex={tabIndex}
        {...props} // eslint-disable-line react/jsx-props-no-spreading
      >
        {children}
      </HeadingElement>
    );
  },
);

Heading.displayName = 'Heading';
